/**
 * isShowNav：//是否显示导航栏，默认显示 true，详情页面设置false，不显示在导航栏中
 * fullPath： 完整路径，高亮左侧导航栏高亮，要和父路由拼接，例如：/zhenyun/quote
 * currentMenuItem： 当前菜单项，要和父路由拼接，相当于在详情页高亮其左侧对应的导航栏项
 * isShowLeftNavgation：是否显示左侧导航栏，默认显示 true，详情页面设置false
 * **/

const zhenyunPageRouters = [
  {
    path: '/partner',
    name: 'zhenyun',
    redirect: '/partner/introduce',
    component: () => import('@/views/zhenyun/index'),
    meta: {
      title: '生态订单',
      unMenu:true,
    },
    children: [
      {
        path: 'introduce',
        name:"partner-introduce",
        component: () => import("@/views/zhenyun/introduce/index.vue"),
        meta: {
          title: '专区介绍',
          fullPath: '/partner/introduce',
          numKey:'',
          needNum:false
        },
      },
      {
        path: 'order-radar',
        name: 'order-radar',
        component: () => import('@/views/zhenyun/order-radar/index.vue'),
        meta: {
          title: '订单雷达',
          isShowNav: true, 
          fullPath: '/partner/order-radar', 
          numKey:'canQuoteRfqNum',
          
        },
        children: [
          {
            path: '',
            name: 'order-radar-list',
            component: () => import('@/views/zhenyun/order-radar/order-list.vue'),
            meta: {
              title: '订单雷达',
              isShowNav: true, //是否显示导航栏，默认显示 true，详情页面设置false，不显示在导航栏中
              fullPath: '/partner/order-radar', //完整路径，要拼父路由的路径 例如：/zhenyun/quote
              unMenu:true,
              
            },
            children: [
              {
                path: '',
                name: 'order-radar-result',
                component: () => import('@/views/zhenyun/order-radar/orderResult.vue'),
                meta: {
                  title: '全部询盘',
                  currentMenuItem: "/partner/order-radar",
                  fullPath: '/partner/order-radar', //完整路径，要拼父路由的路径 例如：/zhenyun/quote
                  isShowNav: true, //是否显示导航栏，默认显示 true，详情页面设置false，不显示在导航栏中
                }
              },
            ]
          },
          {
            path: ':id',
            name: 'order-radar-detail',
            component: () => import('@/views/zhenyun/order-radar/detail.vue'),
            meta: {
              title: '询盘详情',
              isShowNav: false, //是否显示导航栏，默认显示 true，详情页面设置false，不显示在导航栏中
              fullPath: '/partner/order-radar/', //完整路径，要拼父路由的路径 例如：/zhenyun/quote
              currentMenuItem: "/partner/order-radar",
              isShowLeftNavgation:true,
              unMenu:true,
            }
          },
        ]
      },
      {
        path: 'quote',
        name: 'quote',
        component: () => import('@/views/zhenyun/quote-manage/list.vue'),
        meta: {
          title: '我的报价',
          fullPath: '/partner/quote',
          numKey:'totalQuoteNum'
        },
      },
      {
        path: 'created-quote/:id',
        name: 'created-quote',
        component: () =>
          import('@/views/zhenyun/quote-manage/update-quote.vue'),
        meta: {
          title: '创建报价',
          fullPath: '/partner/created-quote',
          currentMenuItem: '/partner/quote',
          isShowNav: false,
          isShowLeftNavgation: true, //是否显示左侧导航栏
        },
      },
      {
        path: 'update-quote/:id',
        name: 'update-quote',
        component: () =>
          import('@/views/zhenyun/quote-manage/update-quote.vue'),
        meta: {
          title: '修改报价',
          fullPath: '/partner/update-quote',
          currentMenuItem: '/partner/quote',
          isShowNav: false,
          isShowLeftNavgation: true, //是否显示左侧导航栏
        },
      },
      {
        path: 'quote/:id',
        name: 'quote-detail',
        component: () =>
          import('@/views/zhenyun/quote-manage/quote-detail.vue'),
        meta: {
          title: '报价详情',
          fullPath: '/partner/quote-detail',
          currentMenuItem: '/partner/quote',
          isShowNav: false,
        },
      },
    ],
  },
  // {
  //   path: '/partner',
  //   name: 'zhenyun-customer',
  //   component: () => import('@/views/zhenyun/index'),
  //   meta: {
  //     title: '生态客户',
  //   },
  //   children: [
  //     {
  //       path: 'transformable-customer',
  //       name: 'transformable-customer',
  //       component: () => import('@/views/zhenyun/zoology-customer/index.vue'),
  //       meta: {
  //         title: '可转化客户池',
  //         fullPath: '/partner/transformable-customer',
  //       },
  //     },
  //   ],
  // },
  {
    path: '/partner',
    name: 'zhenyun-nda',
    component: () => import('@/views/zhenyun/index'),
    meta: {
      title: '协议管理',
      unMenu:true,
    },
    children: [
      // {
      //   path: 'nda',
      //   name: 'nda',
      //   component: () => import('@/views/zhenyun/nda/index.vue'),
      //   meta: {
      //     title: '保密协议申请记录',
      //     fullPath: '/zhenyun/nda',
      //   },
      // },
      {
        path: 'agreement-repository',
        name: 'agreement-repository',
        component: () => import('@/views/zhenyun/agreement-repository/index.vue'),
        meta: {
          title: '协议库',
          fullPath: '/partner/agreement-repository',
          numKey:'agreementsNum',
          
        },
      },
    ],
  },
  {
    path: '/partner',
    name: 'bank-authorize',
    component: () => import('@/views/zhenyun/index'),
    meta: {
      title: '网商银行资金分账授权',
      unMenu:true,
      isShowNav:false,
    },
    children: [
      {
        path: 'bank-authorize',
        name: 'bank-authorize',
        component: () => import('@/views/zhenyun/bank-pay/index.vue'),
        meta: {
          title: '网商银行资金分账授权',
          fullPath: '/partner/bank-authorize',
          numKey:'agreementsNum',
          isShowLeftNavgation:false
        },
      },
    ],
  },
]

export default zhenyunPageRouters
